import styled from 'styled-components';
import { identity } from 'lodash';
import Metric from './Metric';
import LegendSwatch from './LegendSwatch';

export const Metrics = styled.div`
  min-width: 250px;
  max-width: 300px;
  width: 25%;
  flex-shrink: 0;
  border-bottom: 0.5px solid var(--border-color);
  overflow-y: scroll;
  max-height: 100%;
`;

const TabularMetric = styled.div`
  padding: var(--cell-padding);
  padding-right: 1rem;
  border-bottom: 0.5px solid var(--border-color);
  &:hover {
    background-color: rgba(33, 33, 33, 0.03);
  }
`;

/**
 * - `metrics` should be an array of objects to specify which metrics to
 *   display.
 * - `data` should be an object with keys corresponding to the accessor of each
 *   metric the values should be arrays of data to be aggregated. However, if
 *   `aggregator` is not specified, the values should be scalars.
 */
const AggregateMetrics = ({
  metrics,
  data,
  onToggle,
  arrayTransform = identity,
}) => (
  <Metrics>
    {metrics.map(
      ({
        displayName,
        info,
        color,
        accessor,
        aggregator = null,
        format,
        shown,
        transform = identity,
      }) => {
        const arrayOrScalar = data[accessor];
        if (!arrayOrScalar) return null;

        const scalarValue = aggregator
          ? aggregator(arrayTransform(arrayOrScalar))
          : arrayOrScalar;

        const formattedValue = format(transform(scalarValue));

        return (
          <TabularMetric
            key={accessor}
            onClick={() => onToggle(accessor)}
            className="cursor-pointer d-flex justify-content-between align-items-center"
          >
            <Metric
              value={formattedValue}
              info={info}
              label={
                <span
                  style={{ color: shown ? color : '#000' }}
                  className={`${shown ? 'font-weight-bold' : ''}`}
                >
                  {displayName}
                </span>
              }
            />
            <LegendSwatch color={shown ? color : null} />
          </TabularMetric>
        );
      },
    )}
  </Metrics>
);

export default AggregateMetrics;
